// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form styling code */

.floating-label-group {
  position: relative;
}
.helpfloating-label-group {
  position: relative;
}

.floating-label {
  font-size: 16px;
  position: absolute;
  pointer-events: none;
  top: 8px ;
  left: 12px;
  color: #6d6e71;
  font-weight: normal;
  transition: all 0.1s ease;
}



.helpfloating-label {
    font-size: 12px;
    position: absolute;
    pointer-events: none;
    top: 8px;
    left: 20px;
    color: #6d6e71;
    font-weight: normal;
    transition: all 0.1s ease;
}



input:focus ~ .floating-label {
  top: -12px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;

}


input:not(:focus):valid ~ .floating-label,input[type=file]:not(:focus):valid ~ .floating-label , select:not(:focus):valid ~ .floating-label ,textarea:not(:focus):valid ~ .floating-label {
  top: -12px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;

}

/* input:valid ~ .floating-label {
  top: -12px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 14px;
  color: #6d6e71;
  opacity: 1;

} */

input[read-only]:valid ~ .floating-label, input[disabled]:valid ~ .floating-label {
  top: -12px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 14px;
  color: #6d6e71;
  opacity: 1;

}

input[read-only]:focus ~ .floating-label, input[disabled]:focus ~ .floating-label
 {
  top: -12px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}


input[read-only]:not(:focus):valid ~ .floating-label, input[disabled]:not(:focus):valid ~ .floating-label {
  top: 5px;
  left: 18px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 14px;
  color: #6d6e71;
  opacity: 1;
}

input:focus ~ .helpfloating-label,
input:not(:focus):valid ~ .helpfloating-label {
  top: -12px;
  left: 15px;
  background-color: #ffffff;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
  /* top: 10px;
  bottom: 45px;
  left: 25px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1; */
}

input:focus ~ .floating-label,
input:focus:valid ~ .floating-label {
  font-size: 12px;
  top: -12px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

input:focus ~ .helpfloating-label,
input:focus:valid ~ .helpfloating-label {
  font-size: 12px;
  top: -12px;
  left: 15px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

input::content ~ .floating-label,
input::content:valid ~ .floating-label {
  font-size: 12px;
  top: -12px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

input::content ~ .helpfloating-label,
input::content:valid ~ .helpfloating-label {
  font-size: 12px;
  top: -5px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

.textstyle {
  padding-left: 10px;
  padding-top: 22px !important;
  padding-bottom: 6px !important;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  background-color: #ffffff;
  border-radius: 0px;
  /* box-shadow: inset 0px 0px 0px 1px #eee; */
  border: 1px solid #eee;
}

.helptextstyle {
  padding-top: 20px !important;
  padding-bottom: 6px !important;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  /* box-shadow: inset 0px 0px 0px 1px #eee; */
  border: 1px solid #eee;
}
/* select:focus ~ .floating-label,
select:not(:focus):valid ~ .floating-label {
  top: 0px;
  bottom: 30px;
  left: 18px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
} */

select:focus ~ .helpfloating-label,
select:not(:focus):valid ~ .helpfloating-label,
select:not([value=""]):valid ~ .helpfloating-label {
  top: 10px;
  bottom: 45px;
  left: 25px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

select:focus ~ .floating-label,
select:focus:valid ~ .floating-label {
  font-size: 12px;
  top: -12px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

select:focus ~ .helpfloating-label,
select:focus:valid ~ .helpfloating-label {
  font-size: 12px;
  top: -4px;
  left: 15px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

select::content ~ .floating-label,
select::content:valid ~ .floating-label {
  font-size: 12px;
  top: -12px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}

select::content ~ .helpfloating-label,
select::content:valid ~ .helpfloating-label {
  font-size: 12px;
  top: -5px;
  left: 18px;
  background-color: white;
  padding: 0px 10px;
  font-size: 12px;
  color: #6d6e71;
  opacity: 1;
}




/* --------------new css----------- */
`, "",{"version":3,"sources":["webpack://./src/components/textField/textfield.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;;;AAIA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;;;AAIA;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;;AAEZ;;;AAGA;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;;AAEZ;;AAEA;;;;;;;;;GASG;;AAEH;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;;AAEZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;;AAGA;EACE,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;EACV;;;;;eAKa;AACf;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;AACxB;AACA;;;;;;;;GAQG;;AAEH;;;EAGE,SAAS;EACT,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;;;;AAKA,qCAAqC","sourcesContent":["/* Form styling code */\n\n.floating-label-group {\n  position: relative;\n}\n.helpfloating-label-group {\n  position: relative;\n}\n\n.floating-label {\n  font-size: 16px;\n  position: absolute;\n  pointer-events: none;\n  top: 8px ;\n  left: 12px;\n  color: #6d6e71;\n  font-weight: normal;\n  transition: all 0.1s ease;\n}\n\n\n\n.helpfloating-label {\n    font-size: 12px;\n    position: absolute;\n    pointer-events: none;\n    top: 8px;\n    left: 20px;\n    color: #6d6e71;\n    font-weight: normal;\n    transition: all 0.1s ease;\n}\n\n\n\ninput:focus ~ .floating-label {\n  top: -12px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n\n}\n\n\ninput:not(:focus):valid ~ .floating-label,input[type=file]:not(:focus):valid ~ .floating-label , select:not(:focus):valid ~ .floating-label ,textarea:not(:focus):valid ~ .floating-label {\n  top: -12px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n\n}\n\n/* input:valid ~ .floating-label {\n  top: -12px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 14px;\n  color: #6d6e71;\n  opacity: 1;\n\n} */\n\ninput[read-only]:valid ~ .floating-label, input[disabled]:valid ~ .floating-label {\n  top: -12px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 14px;\n  color: #6d6e71;\n  opacity: 1;\n\n}\n\ninput[read-only]:focus ~ .floating-label, input[disabled]:focus ~ .floating-label\n {\n  top: -12px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\n\ninput[read-only]:not(:focus):valid ~ .floating-label, input[disabled]:not(:focus):valid ~ .floating-label {\n  top: 5px;\n  left: 18px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 14px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\ninput:focus ~ .helpfloating-label,\ninput:not(:focus):valid ~ .helpfloating-label {\n  top: -12px;\n  left: 15px;\n  background-color: #ffffff;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n  /* top: 10px;\n  bottom: 45px;\n  left: 25px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1; */\n}\n\ninput:focus ~ .floating-label,\ninput:focus:valid ~ .floating-label {\n  font-size: 12px;\n  top: -12px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\ninput:focus ~ .helpfloating-label,\ninput:focus:valid ~ .helpfloating-label {\n  font-size: 12px;\n  top: -12px;\n  left: 15px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\ninput::content ~ .floating-label,\ninput::content:valid ~ .floating-label {\n  font-size: 12px;\n  top: -12px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\ninput::content ~ .helpfloating-label,\ninput::content:valid ~ .helpfloating-label {\n  font-size: 12px;\n  top: -5px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\n.textstyle {\n  padding-left: 10px;\n  padding-top: 22px !important;\n  padding-bottom: 6px !important;\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n  background-color: #ffffff;\n  border-radius: 0px;\n  /* box-shadow: inset 0px 0px 0px 1px #eee; */\n  border: 1px solid #eee;\n}\n\n.helptextstyle {\n  padding-top: 20px !important;\n  padding-bottom: 6px !important;\n  font-size: 12px;\n  font-weight: 400;\n  color: #000;\n  /* box-shadow: inset 0px 0px 0px 1px #eee; */\n  border: 1px solid #eee;\n}\n/* select:focus ~ .floating-label,\nselect:not(:focus):valid ~ .floating-label {\n  top: 0px;\n  bottom: 30px;\n  left: 18px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n} */\n\nselect:focus ~ .helpfloating-label,\nselect:not(:focus):valid ~ .helpfloating-label,\nselect:not([value=\"\"]):valid ~ .helpfloating-label {\n  top: 10px;\n  bottom: 45px;\n  left: 25px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\nselect:focus ~ .floating-label,\nselect:focus:valid ~ .floating-label {\n  font-size: 12px;\n  top: -12px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\nselect:focus ~ .helpfloating-label,\nselect:focus:valid ~ .helpfloating-label {\n  font-size: 12px;\n  top: -4px;\n  left: 15px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\nselect::content ~ .floating-label,\nselect::content:valid ~ .floating-label {\n  font-size: 12px;\n  top: -12px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\nselect::content ~ .helpfloating-label,\nselect::content:valid ~ .helpfloating-label {\n  font-size: 12px;\n  top: -5px;\n  left: 18px;\n  background-color: white;\n  padding: 0px 10px;\n  font-size: 12px;\n  color: #6d6e71;\n  opacity: 1;\n}\n\n\n\n\n/* --------------new css----------- */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
